document.addEventListener("DOMContentLoaded", function () {
    const content = document.querySelector('.article-template__content');
    if (!content) return;

    // 1. Collect all images inside article
    const images = content.querySelectorAll('img');
    let gallery = [];

    images.forEach((img, index) => {
        // Skip icons / tiny images if needed
        if (img.closest('.post-cta')) return;

        let src = img.getAttribute('src');
        src = src.replace(/_\d+x\./, '.');

        if (!src) return;

        gallery.push(src);

        // Wrap image with clickable link
        if (!img.closest('.lightbox-link')) {
            const link = document.createElement('a');
            link.href = src;
            link.classList.add('lightbox-link');
            link.dataset.index = gallery.length - 1;

            img.parentNode.insertBefore(link, img);
            link.appendChild(img);
        }
    });

    // 2. Create lightbox HTML (auto inject)
    const lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.innerHTML = `
    <span class="lightbox__close">&times;</span>
    <span class="lightbox__prev">&#10094;</span>
    <img class="lightbox__img" src="">
    <span class="lightbox__next">&#10095;</span>
  `;
    document.body.appendChild(lightbox);

    const lightboxImg = lightbox.querySelector('.lightbox__img');
    const closeBtn = lightbox.querySelector('.lightbox__close');
    const prevBtn = lightbox.querySelector('.lightbox__prev');
    const nextBtn = lightbox.querySelector('.lightbox__next');

    let currentIndex = 0;
    let zoomed = false;

    function showImage(index) {
        const total = gallery.length;

        // LOOP
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;

        currentIndex = index;
        lightboxImg.src = gallery[currentIndex];

        zoomed = false;
        lightboxImg.classList.remove('zoomed');

        lightboxImg.style.transformOrigin = 'center center';
    }

    lightboxImg.addEventListener('click', function (e) {
        e.stopPropagation();

        zoomed = !zoomed;

        if (zoomed) {
            const x = (e.clientX / window.innerWidth) * 100;
            const y = (e.clientY / window.innerHeight) * 100;
            lightboxImg.style.transformOrigin = `${x}% ${y}%`;

            lightboxImg.classList.add('zoomed');
        } else {
            lightboxImg.classList.remove('zoomed');

            setTimeout(() => {
                if (!zoomed) lightboxImg.style.transformOrigin = 'center center';
            }, 300);
        }
    });

    lightbox.addEventListener('mousemove', function (e) {
        if (!zoomed) return;

        const x = (e.clientX / window.innerWidth) * 100;
        const y = (e.clientY / window.innerHeight) * 100;

        lightboxImg.style.transformOrigin = `${x}% ${y}%`;
    });

    // 3. Click events
    document.querySelectorAll('.lightbox-link').forEach((link) => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            currentIndex = parseInt(this.dataset.index);
            lightbox.style.display = 'flex';
            showImage(currentIndex);
        });
    });

    // Controls
    closeBtn.onclick = () => lightbox.style.display = 'none';
    prevBtn.onclick = () => showImage(currentIndex - 1);
    nextBtn.onclick = () => showImage(currentIndex + 1);

    // Click outside image
    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) lightbox.style.display = 'none';
    });

    // Keyboard support
    document.addEventListener('keydown', (e) => {
        if (lightbox.style.display !== 'flex') return;

        if (e.key === 'Escape') lightbox.style.display = 'none';
        if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
        if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });
});
